<template>
  <div class="tw-pl-2 tw-pr-4">
    <div class="tw-pb-2">
      <QuillTextareaGroup
        label="Program Description"
        instruct="Give a small description about the program"
        name="description"
        type="text"
        placeholder="name"
        input-classes="tw-p-3 focus:tw-bg-gray-100"
        v-model="description"
        :error="descriptionError"
        :rows="4"
      />
    </div>
    <div class="tw-flex tw-items-center tw-justify-end">
      <BaseButton
        text="Cancel"
        class="tw-border-0 tw-bg-app-black-11"
        @click="cancelEditing"
        :disabled="savingDescription"
      />
      <BaseButton
        text="Save"
        class="tw-border-0 tw-bg-black tw-text-white tw-ml-2"
        @click="saveProgramDescription"
        :disabled="savingDescription"
      />
    </div>
  </div>
</template>

<script>
import QuillTextareaGroup from '@/components/QuillTextareaGroup.vue';
import form from '@/modules/formHelper';

export default {
  name: 'EditCompanyProgramDescription',
  components: {
    QuillTextareaGroup,
  },
  props: {
    companyProgram: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      description: this.companyProgram.description,
      descriptionError: undefined,
      savingDescription: false,
    };
  },
  methods: {
    cancelEditing() {
      this.$emit('cancel-editing');
    },
    async saveProgramDescription() {
      if (!form.isValidTextInput(this.description)) return;

      this.savingDescription = true;

      const formData = {
        progid: this.companyProgram.id,
        desc: this.description,
      };

      const response = await this.$store.dispatch('editProgramDescription', formData);

      if (!response) {
        this.$toasted.global.appError({ errorMessage: 'Could not save new program description' });
      } else {
        this.$toasted.success('Program description saved', {
          duration: 3500,
          position: 'top-right',
        });

        this.$emit('description-saved');
      }

      this.savingDescription = false;
    },
  },
};
</script>

<style>

</style>
